
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cleartax.in/itr-2-filing/integrations",
      function () {
        return require("private-next-pages/cleartax.in/itr-2-filing/integrations/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cleartax.in/itr-2-filing/integrations"])
      });
    }
  